var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 18.333h-15a.834.834 0 0 1-.833-.833v-6.667c0-.46.374-.833.833-.833h.834v.833H2.5V17.5h15v-6.667h-.833V10h.833c.46 0 .834.373.834.833V17.5c0 .46-.374.833-.834.833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.334 7.255.589-.588 5.586 5.338c.27.271.71.271.982 0l5.586-5.339.589.59-5.587 5.338a1.53 1.53 0 0 1-2.16 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.417 1.667h-.833V12.5h.833z"
  })));
};
export default SvgDownload;